import React from 'react';
import { Cell } from 'react-table';
import { Link } from 'react-router-dom';

import { TitleFilenameLabel, Tooltip } from '../..';
import { TooltipColumn } from '../types';
import { defaultCellWidth, defaultTooltipPosition } from '../constants';

interface SongTitleCellProps {
    cell: Cell<SongTitleItem>;
    column: TooltipColumn<SongTitleItem>;
}

export const SongTitleCell = ({
    cell,
    column,
}: SongTitleCellProps): JSX.Element => {
    const position = column?.tooltipPosition ?? defaultTooltipPosition;
    const width = (column?.width as number) ?? defaultCellWidth;
    const {
        value: { audioDeleted, filename, href, isNew, title },
    } = cell;

    const textWidth = width - 30;

    const message =
        title && filename ? `${title} / ${filename}` : title || filename;

    return (
        <Tooltip message={message} position={position}>
            <div className="flex items-center">
                {href && (
                    <Link to={href}>
                        <TitleFilenameLabel
                            audioDeleted={audioDeleted}
                            filename={filename}
                            isNew={isNew}
                            title={title}
                            width={textWidth}
                            underline={true}
                        />
                    </Link>
                )}
                {!href && (
                    <TitleFilenameLabel
                        audioDeleted={audioDeleted}
                        filename={filename}
                        isNew={isNew}
                        title={title}
                        width={textWidth}
                        underline={false}
                    />
                )}
            </div>
        </Tooltip>
    );
};
